import React, { useEffect, useState } from "react";
import { Checkbox, DatePicker, Form, Modal, message } from "antd";
import dayjs from "dayjs";
import { fillSprHolidays } from "./spr-holidays-api";
import "./spr-holidays.css";

const WEEKDAY_OPTIONS = [
  { value: 1, label: "Пн" },
  { value: 2, label: "Вт" },
  { value: 3, label: "Ср" },
  { value: 4, label: "Чт" },
  { value: 5, label: "Пт" },
  { value: 6, label: "Сб" },
  { value: 7, label: "Вс" }
];

/**
 * Диалог массового заполнения (Delphi TFrmSprHolidaysFill).
 * По умолчанию отмечены Пт и Сб.
 */
const SprHolidaysFillModal = ({ open, year, onClose, onFilled }) => {
  const [form] = Form.useForm();
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue({
      begPer: dayjs(`${year}-01-01`),
      endPer: dayjs(`${year}-12-31`),
      weekdays: [5, 6],
      clear: false
    });
  }, [open, year, form]);

  const onOk = async () => {
    try {
      const values = await form.validateFields();
      const beg = values.begPer;
      const end = values.endPer;
      if (!beg || !end) {
        message.error("Укажите период");
        return;
      }
      if (end.isBefore(beg, "day")) {
        message.error("Конец периода раньше начала");
        return;
      }
      const weekdays = values.weekdays || [];
      if (!weekdays.length) {
        message.error("Укажите хотя бы один день недели");
        return;
      }

      setBusy(true);
      await fillSprHolidays({
        begPer: beg.format("YYYY-MM-DD"),
        endPer: end.format("YYYY-MM-DD"),
        weekdays,
        clear: !!values.clear
      });
      message.success("Заполнено");
      onFilled?.();
      onClose?.();
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e.message || "Не удалось заполнить");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      className="spr-holidays-fill-modal"
      title="Заполнить"
      open={open}
      onCancel={busy ? undefined : onClose}
      onOk={onOk}
      okText="ОК"
      cancelText="Отмена"
      confirmLoading={busy}
      destroyOnClose
      width={560}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        className="spr-holidays-fill-form"
      >
        <div className="spr-holidays-fill-form__period">
          <Form.Item
            name="begPer"
            label="С"
            rules={[{ required: true, message: "Укажите начало" }]}
          >
            <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="endPer"
            label="По"
            rules={[{ required: true, message: "Укажите конец" }]}
          >
            <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
          </Form.Item>
        </div>
        <Form.Item name="weekdays" label="Дни недели" rules={[{ required: true, message: "Выберите дни" }]}>
          <Checkbox.Group className="spr-holidays-fill-form__weekdays">
            {WEEKDAY_OPTIONS.map((opt) => (
              <Checkbox key={opt.value} value={opt.value}>
                {opt.label}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </Form.Item>
        <Form.Item name="clear" valuePropName="checked" className="spr-holidays-fill-form__clear">
          <Checkbox>Очистить перед заполнением</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SprHolidaysFillModal;
